<template>
  <div>
    <div>
      <div class="headCont">
        <div class="slelectCont">
          <a-dropdown overlayClassName="dropcla">
            <div class="lxBox dis-cent">
              <div class="name">{{ jobs_name }}</div>
              <div class="iconfont icon-unfold unfold"></div>
            </div>
            <a-menu
              slot="overlay"
              @click="hyClick"
              :selectedKeys="[category_id]"
            >
              <a-menu-item
                :key="item.subclass + '_' + item.id"
                v-for="item in xzList"
                >{{ item.jobs_name }}</a-menu-item
              >
            </a-menu>
          </a-dropdown>
          <a-dropdown>
            <div class="lxBox dis-cent">
              <div class="name">{{ currentTxt }}</div>
              <div class="iconfont icon-unfold unfold"></div>
            </div>
            <a-menu
              slot="overlay"
              @click="hyClick1"
              :selectedKeys="[typeData['目前状态']]"
            >
              <a-menu-item
                :key="item.id + '_' + item.c_name"
                v-for="item in current"
                >{{ item.c_name }}</a-menu-item
              >
            </a-menu>
          </a-dropdown>
          <a-dropdown>
            <div class="lxBox dis-cent">
              <div class="name">{{ leixTxt }}</div>
              <div class="iconfont icon-unfold unfold"></div>
            </div>
            <a-menu
              slot="overlay"
              @click="hyClick2"
              :selectedKeys="[typeData['时间']]"
            >
              <a-menu-item
                :key="item.id + '_' + item.name"
                v-for="item in leixList"
                >{{ item.name }}</a-menu-item
              >
            </a-menu>
          </a-dropdown>
        </div>
        <div class="typeCont">
          <!-- <div class="typeList">
            <div
              class="type dis-cent"
              v-for="item in typeList"
              :class="typeOn == item.id ? 'on' : ''"
            >
              {{ item.name }}
            </div>
          </div> -->
          <!-- <div class="inputBox">
            <input
              type="text"
              placeholder="请输入关键词搜索，如：机床，销售等"
              v-model="searChTxt"
              @keyup.enter="searchClick"
            />
          </div> -->
          <!-- <div class="leixList">
            <div
              class="lxBox dis-cent"
              :class="item.id == leixOn ? 'on' : ''"
              v-for="item in leixList"
              @click="leixClick(item.id)"
            >
              {{ item.name }}
            </div>
          </div> -->
          <!-- <div class="txt">
            注：查看全部人才信息请点击左侧第二个搜索人才字样，右侧可以切换岗位发现推荐人才
          </div> -->
        </div>
      </div>
      <div class="content">
        <Kong v-if="list.length == 0" />
        <div
          class="cont"
          :class="item.member_info.is_read ? 'anse' : ''"
          v-for="(item, index) in list"
          @click="jump(item.member_info.member_id)"
        >
          <div class="contLeft">
            <div class="imgBox">
              <div class="img">
                <img
                  :src="
                    item.member_info.avatars
                      ? $imgUrl + item.member_info.avatars
                      : 'https://www.yhrl.com/static/avatar/man.png'
                  "
                  alt=""
                />
          
              </div>
              <div class="money dis-cent" v-if="item.member_info.member_job">
                
                {{ item.member_info.member_job[0].minprice }}k-{{
                  item.member_info.member_job[0].maxprice
                }}k
              </div>
            </div>
          </div>
          <div class="contRit">
            <div class="name">
              {{
                daysNum > 0
                  ? item.member_info.realname
                  : "NO." + item.member_info.member_id
              }}<span v-if="daysNum > 0"> · {{ item.member_info.phone }}</span>
              <span
                style="margin-left: 15px"
                v-if="item.member_info.is_interview"
                >[已预约过面试]</span
              >
            </div>
            <div class="txtBox">
              <div class="txt">{{ item.member_info.sex_cn }}</div>
              <div class="shu"></div>
              <div class="txt" v-if="item.age != 2024">{{ item.age }}岁</div>
              <div class="txt" v-if="item.age == 2024">未填写</div>
              <div class="shu"></div>
              <div class="txt">
                {{
                  item.member_info.experience_cn
                    ? item.member_info.experience_cn
                    : "未填写"
                }}
              </div>
              <div class="shu"></div>
              <div class="txt">
                {{
                  item.member_info.current_cn
                    ? item.member_info.current_cn
                    : "未填写"
                }}
              </div>
              <div class="shu"></div>
            </div>
            <div class="textBox">
              <div class="txt">期望:</div>
              <div class="text" v-if="item.member_info.member_job">
                {{ item.member_info.member_job[0].intention_jobs }}
              </div>
            </div>
            <div class="textBox">
              <div class="txt">优势:</div>
              <div class="text c-1">
                {{
                  item.member_info.speciality
                    ? item.member_info.speciality
                    : "暂未填写优势"
                }}
              </div>
            </div>
            <!-- <div class="textBox">
              <div class="txt1">最新登录时间:</div>
              <div class="text1">{{ item.login_time }}</div>
            </div> -->
            <div class="textBox">
              <div class="txt1">求职更新时间:</div>
              <div class="text1">{{ item.gxtime }}</div>
            </div>
            <div class="typeBox">
              <div class="txt" v-if="item.member_info.education_cn">
                {{ item.member_info.education_cn }}
              </div>
              <template v-if="item.member_info.member_job">
                <template v-if="item.member_info.member_job[0].district_cn1">
                  <div
                    class="txt"
                    v-for="itemq in item.member_info.member_job[0].district_cn1"
                  >
                    {{ itemq }}
                  </div>
                </template>
                <template v-else>
                  <div class="txt">
                    {{ item.member_info.member_job[0].district_cn }}
                  </div>
                </template>
              </template>
            </div>
          </div>
          <div class="contJl">
            <div class="lcLi" v-if="item.member_info.member_experience">
              <div class="iconBox">
                <div class="icon">
                  <div class="iconfont icon--_liepinqiuzhi liepinqiuzhi"></div>
                </div>
                <div class="shu"></div>
              </div>
              <div class="boxs">
                <div
                  class="box"
                  v-for="job in item.member_info.member_experience"
                >
                  <div class="time">
                    {{ job.start_time ? job.start_time : "未填写" }} -
                    {{ job.end_time ? job.end_time : "未填写" }}
                  </div>
                  <div class="textBox">
                    <div class="text">{{ job.companyname }}</div>
                    <div class="yuan"></div>
                    <div class="text">{{ job.jobs }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lcLi" v-if="item.member_info.member_education.id != 0">
              <div class="iconBox">
                <div class="icon">
                  <div class="iconfont icon-xuexiao xuexiao"></div>
                </div>
              </div>
              <div class="boxs">
                <div class="box">
                  <div class="time">
                    {{ item.member_info.member_education.start_time }} -
                    {{ item.member_info.member_education.end_time }}
                  </div>
                  <div class="textBox c-1">
                    <div class="text">
                      {{ item.member_info.member_education.school }}
                    </div>
                    <div class="yuan"></div>
                    <div class="text">
                      {{ item.member_info.member_education.speciality }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="goutong">
            <div
              class="box dis-cent"
              @click.stop="messageClick(item.member_info.member_id)"
            >
              打招呼
            </div>
            <div
              class="csbox dis-cent"
              @click.stop="scClick(item.member_info.member_id, index)"
            >
              {{ item.member_info.is_favorite ? "取消收藏" : "收藏" }}
            </div>
            <div
              class="csbox dis-cent"
              @click.stop="dpClick(item.member_info.member_id)"
            >
              点评
            </div>
          </div>
        </div>
        <div class="fenye" v-if="totalCount > 6">
          <a-pagination
            :default-current="page.pageNo"
            v-model="page.pageNo"
            :total="totalCount"
            :page-size="6"
            @change="pageOnChange"
          />
        </div>
      </div>
      <Jianli v-if="jlShow" :id="peoId" @show="jlShowJs" />
      <Dianping v-if="dianpingShow" @show="dpDelClick" :id="peoId" />
    </div>
  </div>
</template>

<script>
import {
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  message,
} from "ant-design-vue";
import LoginZj from "../../component/loginZj.vue";
import Jianli from "../../component/jianli.vue";
import html2pdf from "html2pdf.js";
import Kong from "../../component/kong.vue";
import Dianping from "../../component/dianping.vue";
export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    LoginZj,
    Jianli,
    Kong,
    Dianping,
  },
  name: "",
  data() {
    return {
      dianpingShow: false,
      daysNum: 0,
      shang: "",
      searChTxt: "",
      typeOn: 0,
      typeList: [
        {
          id: "",
          name: "匹配人才",
        },
      ],
      xzList: [],
      jlShow: false,
      xzKey: "选择推荐岗位",
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 6,
        refreshtime: 90,
      },
      list: [],
      totalCount: 0,
      category_id: "",
      jobs_name: "选择推荐岗位",
      peoId: "",
      jobId: 0,
      mrid: 0,
      mrtype: 0,
      leixOn: 90,
      currentTxt: "求职状态",
      currentId: "",
      current: [],
      typeData: {
        目前状态: "",
        时间: "",
      },
      leixTxt: "更新时间",
      leixList: [
        {
          id: 7,
          name: "一周",
        },
        {
          id: 30,
          name: "一个月",
        },
        {
          id: 90,
          name: "三个月",
        },
        {
          id: 180,
          name: "六个月",
        },
        {
          id: 360,
          name: "一年",
        },
      ],
    };
  },
  created() {
    this.mrid = this.$route.query.id;
    this.mrtype = this.$route.query.type;
    this.typeGet();
    let category_gets = window.localStorage.getItem("category_gets");
    if (category_gets) {
      this.category_gets = JSON.parse(category_gets);
      this.typeHcGet(this.category_gets);
    } else {
      this.zhuangtai();
    }
    this.vipGet();
  },
  props: ["id"],
  watch: {
    id(val) {
      console.log(val);
      this.mrid = this.$route.query.id;
      this.mrtype = this.$route.query.type;
      this.totalCount = 0;
      this.typeGet();
    },
  },
  methods: {
    dpClick(id) {
      this.peoId = id;
      this.dianpingShow = true;
    },
    dpDelClick(id) {
      this.dianpingShow = false;
    },
    vipGet() {
      this.$get("/nozzle/web/company_vip").then((res) => {
        console.log(res);
        let startDate = this.$moment().format();
        let dateTimeStamp = this.$moment(res.vip.endtime * 1000).format();
        dateTimeStamp = this.$moment(dateTimeStamp);
        this.daysNum = dateTimeStamp.diff(startDate, "days");
      });
    },
    zhuangtai() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        window.localStorage.setItem("category_gets", JSON.stringify(res.data));
        this.typeHcGet(res.data);
      });
    },
    typeHcGet(data) {
      // 所属行业
      let current = [
        {
          id: "",
          c_name: "全部状态",
        },
      ];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        e.select = false;
        if (e.c_alias == "QS_current") {
          current.push(e);
        }
      }
      this.current = current;
    },
    leixClick(id) {
      this.leixOn = id;
      this.page.refreshtime = id;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    copyClick(mobile) {
      const textarea = document.createElement("textarea");
      textarea.value = mobile;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("复制电话成功");
    },
    pageOnChange(i) {
      this.page.pageNo = i;
      this.listGet();
    },
    typeClick(id) {
      this.typeOn = id;
      this.page.odb = id;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    typeGet() {
      this.$get("/nozzle/web/company_groupby").then((res) => {
        console.log(res.data);
        this.xzList = res.data;
        if (res.data) {
          if (this.mrid) {
            for (let i = 0; i < res.data.length; i++) {
              const e = res.data[i];
              if (this.mrid == e.id) {
                this.category_id = e.subclass + "_" + e.id;
                this.jobId = e.id;
                this.jobs_name = e.jobs_name;
                this.page.subclass = e.subclass;
                this.page.id = e.id;
              }
            }
          } else {
            this.category_id = res.data[0].subclass + "_" + res.data[0].id;
            this.jobId = res.data[0].id;
            this.jobs_name = res.data[0].jobs_name;
            this.page.subclass = res.data[0].subclass;
            this.page.id = res.data[0].id;
          }
          this.$forceUpdate();
          this.listGet();
        }
      });
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/company_member2", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        const currentYear = new Date().getFullYear();
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.login_time = this.$moment(e.login_time).format("YYYY年M月D日");
            if (e.member_info.refreshtime) {
              let gxtime = this.$moment(
                e.member_info.refreshtime * 1000
              ).format();
              gxtime = this.$moment(gxtime).format("YYYY年M月D日");
              e.gxtime = gxtime;
            } else {
              e.gxtime = "";
            }
            if (e.member_info.birthday) {
              e.age = currentYear - Number(e.member_info.birthday);
            }
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    hyClick(e) {
      this.category_id = e.key;
      console.log(e.key);
      this.jobId = e.key.split("_")[1];
      this.page.subclass = e.key.split("_")[0];
      this.page.id = e.key.split("_")[1];
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
      for (let i = 0; i < this.xzList.length; i++) {
        const ei = this.xzList[i];
        if (ei.id == e.key.split("_")[1]) {
          this.jobs_name = ei.jobs_name;
          this.$forceUpdate();
        }
      }
    },
    hyClick1(e) {
      console.log(e);
      let key = e.key.split("_");
      this.currentTxt = key[1];
      this.page.current = key[0];
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
      this.$forceUpdate();
    },
    hyClick2(e) {
      console.log(e);
      let key = e.key.split("_");
      this.leixTxt = key[1];
      this.page.refreshtime = key[0];
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
      this.$forceUpdate();
    },
    jlShowJs() {
      this.jlShow = false;
      this.canScroll();
    },
    scClick(id) {
      this.$post("/nozzle/web/favorite_save", {
        id: id,
        genre: 3,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.page.pageNo = 1;
          this.totalCount = 0;
          this.listGet();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    messageClick(id) {
      this.$post("/chat/chat_begin", {
        id: id,
        job_id: this.jobId,
        user_type: 2,
      }).then((res) => {
        // console.log(res);
        if (res.data.status == 1) {
          this.$router.push({
            path: "/gongsi/message",
            query: {
              id,
              job_id: this.jobId,
            },
          });
          // window.open("#/gongsi/message?job_id=" + this.jobId + "&id=" + id);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    jump(id) {
      this.peoId = id;
      this.jlShow = true;
      this.stopScroll();
    },
    //禁止滚动
    stopScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    xzClick(i) {
      this.xzList.splice(i, 1);
    },
    delClick() {
      this.xzList = [];
    },
    searchClick() {
      this.page.name = this.searChTxt;
      this.totalCount = 0;
      this.page.pageNo = 1;
      this.list = [];
      this.listGet();
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.ant-dropdown-menu {
  max-height: 250px;
  overflow: auto;
}
.headCont {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 10px;
  // height: 60px;

  .typeCont {
    display: flex;
    align-items: center;

    .txt {
      font-size: 12px;
      margin-left: 15px;
      color: #666;
    }

    .inputBox {
      width: 300px;
      height: 35px;
      background-color: #dfedfa;
      margin-left: 20px;
      border-radius: 10px;

      input {
        width: 100%;
        height: 100%;
        padding-left: 15px;
        box-sizing: border-box;
        font-size: 14px;
      }
    }
  }

  .leixList {
    display: flex;
    padding-left: 10px;

    .lxBox {
      margin-left: 15px;
      background-color: #dfedfa;
      height: 30px;
      padding: 0 10px;
      border-radius: 5px;
      color: #666;
      font-size: 13px;
      cursor: pointer;
    }

    .on {
      background-color: #dfedfa;
      color: #147ee0;
      font-weight: 600;
    }
  }

  .typeList {
    display: flex;
    align-items: center;

    .type {
      width: 70px;
      height: 30px;
      cursor: pointer;
      border-radius: 5px;
    }

    .on {
      background-color: #dfedfa;
      color: #147ee0;
    }
  }

  .slelectCont {
    display: flex;
    align-items: center;

    .ssBox {
      height: 35px;
      background-color: #fff;
      width: 160px;
      border-radius: 5px;
      display: flex;

      input {
        width: calc(100% - 35px);
        box-sizing: border-box;
        padding-left: 15px;
      }

      .search {
        width: 35px;
        height: 40px;
        color: #9c9c9c;
        font-size: 18px;
      }
    }

    .lxBox {
      margin-right: 15px;
      height: 40px;
      background-color: #fff;
      border-radius: 5px;
      cursor: pointer;
      color: #666;
      padding: 0 12px 0 15px;

      .unfold {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
}

.content {
  .cont {
    cursor: pointer;
    width: 100%;
    border-radius: 5px;
    background-color: #fff;
    padding: 15px 20px;
    margin-bottom: 15px;
    display: flex;

    .contLeft {
      width: 60px;

      .imgBox {
        width: 60px;

        .img {
          height: 60px;
          width: 60px;
          border-radius: 50%;

          img {
            border-radius: 50%;
          }
        }

        .money {
          width: 60px;
          height: 20px;
          border-radius: 20px;
          background-color: #f34e1c;
          color: #fff;
          margin-top: 10px;
          font-size: 12px;
          font-weight: 600;
        }
      }
    }

    .contRit {
      width: calc(45% - 60px);
      padding-left: 25px;
      box-sizing: border-box;
      padding-right: 25px;

      .name {
        font-weight: 500;
        font-size: 16px;

        span {
          font-weight: 400;
          font-size: 14px;
        }
      }

      .txtBox {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 5px;

        .shu {
          width: 1px;
          height: 13px;
          background-color: #c9c9c9;
          margin: 0 8px;
        }

        .shu:last-child {
          display: none;
        }
      }

      .textBox {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 5px;

        .txt {
          color: #999;
          width: 35px;
        }

        .txt1 {
          color: #999;
          margin-right: 7px;
        }

        .text {
          width: calc(100% - 35px);
        }

        .texts {
          display: flex;
          align-items: center;
          width: calc(100% - 35px);

          .yuan {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #c9c9c9;
            margin: 0 6px;
          }
        }
      }

      .typeBox {
        display: flex;
        margin-top: 10px;

        .txt {
          padding: 3px 6px;
          background-color: #f0f3f7;
          margin-right: 10px;
          border-radius: 5px;
          color: #333;
          font-size: 12px;
        }
      }
    }

    .contJl {
      width: calc(55% - 80px);
      display: flex;
      flex-direction: column;
      justify-content: center;

      .lcLi {
        display: flex;
        width: 100%;
        font-size: 13px;

        .iconBox {
          width: 22px;
          display: flex;
          align-items: center;
          flex-direction: column;
          color: #b4b4b4;

          .icon {
            width: 16px;
            height: 20px;
            overflow: hidden;
          }

          .shu {
            border-left: 1px dashed #dadada;
            width: 1px;
            height: calc(100% - 20px);
          }

          .xuexiao {
            font-size: 19px;
            position: relative;
            top: -5px;
            left: -1px;
          }

          .liepinqiuzhi {
            font-size: 14px;
            position: relative;
            left: 1px;
          }
        }

        .boxs {
          width: calc(100% - 22px);

          .box {
            padding-left: 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-bottom: 5px;

            .time {
              width: 130px;
              color: #9c9c9c;
            }

            .textBox {
              width: calc(100% - 130px);
              display: flex;
              align-items: center;

              .yuan {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: #c9c9c9;
                margin: 0 10px;
              }
            }
          }
        }
      }
    }

    .goutong {
      width: 80px;

      .box {
        height: 40px;
        background-color: #147ee0;
        color: #fff;
        border-radius: 5px;
      }

      .csbox {
        background-color: #c90e0e;
        color: #fff;
        height: 40px;
        border-radius: 5px;
        margin-top: 10px;
      }
    }
  }
  .anse {
    color: #999;
  }
}
</style>
